import axios from 'axios';
import {backendHost} from '../../../../store/config';

const postCreateGameFreespin = (params) => {
    return axios.post(`${backendHost}/api/admin/fs-game/add`, params);
};

export {
    postCreateGameFreespin
}